import axios from "axios";
import { API_ORIGIN } from "./apiConfig";

const USP_BASE_URL = `${API_ORIGIN}/usp`;

export const INSTITUTIONAL_PROFILE_KEY = "institutional-profile";
export const EXPERT_ROSTER_KEY = "expert-roster";

export interface SiteDocument {
    docKey: string;
    fileName: string;
    originalFileName?: string;
    updatedAt?: string;
}

const getAuthHeaders = () => {
    const token = localStorage.getItem("admin_access_token");
    return {
        "Content-Type": "application/json",
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
    };
};

// Public download URL (served with Content-Disposition: attachment)
export const getDocumentDownloadUrl = (fileName: string) =>
    `${API_ORIGIN}/api/assets/download/${encodeURIComponent(fileName)}`;

export const getDocumentViewUrl = (fileName: string) =>
    `${API_ORIGIN}/api/assets/view/${encodeURIComponent(fileName)}`;

export const getPublicDocument = async (docKey: string): Promise<SiteDocument> => {
    const response = await axios.get(`${USP_BASE_URL}/documents/${docKey}`);
    return response.data;
};

export const getAdminDocuments = async (): Promise<SiteDocument[]> => {
    try {
        const response = await axios.get(`${USP_BASE_URL}/admin/documents`, { headers: getAuthHeaders() });
        return response.data;
    } catch (error: any) {
        console.error("Error fetching documents:", error);
        throw error.response?.data || { message: "Something went wrong" };
    }
};

export const updateDocument = async (
    docKey: string,
    data: { fileName: string; originalFileName?: string }
): Promise<SiteDocument> => {
    try {
        const response = await axios.put(`${USP_BASE_URL}/admin/documents/${docKey}`, data, {
            headers: getAuthHeaders(),
        });
        return response.data;
    } catch (error: any) {
        console.error(`Error updating document ${docKey}:`, error);
        throw error.response?.data || { message: "Something went wrong" };
    }
};
